import { z } from "zod";
import { createdTimeAway } from "./leave.validator";
import { createdProfile } from "./profile.validators";

const googleCander = z.object({
	summary: z.string().optional(),
	description: z.string().optional(),
	start: z.string().datetime().optional(),
	end: z.string().datetime().optional(),
	link: z.string().url().datetime().optional(),
	attendees: z.string().email().array().optional(),
	country: z.string().optional(),
});
export type GoogleCalendar = z.infer<typeof googleCander>;

export const externalCalendarEvents = googleCander.array();

export type ExternalCalendarEvents = z.infer<typeof externalCalendarEvents>;

export const leavesCalendar = z
	.object({
		leave: createdTimeAway.pick({
			id: true,
			startDate: true,
			endDate: true,
			timeAwayTypeId: true,
		}),
		profile: createdProfile.pick({
			id: true,
			firstName: true,
			lastName: true,
			profilePicture: true,
		}),
	})
	.array();

export const birthdaysCalendar = z
	.object({
		firstName: z.string(),
		lastName: z.string(),
		birthDate: z.string().date(),
		nextBirthday: z.string().date(),
		picUrl: z.string().url().nullable(),
	})
	.array();
export type BirthdaysCalendar = z.infer<typeof birthdaysCalendar>;

export const anniversariesCalendar = z
	.object({
		firstName: z.string(),
		lastName: z.string(),
		joinDate: z.string().date(),
		nextAnniversary: z.string().date(),
		years: z.number(),
		picUrl: z.string().url().nullable(),
	})
	.array();
export type AnniversariesCalendar = z.infer<typeof anniversariesCalendar>;

export const calendarType = z.enum([
	"google",
	"google-holiday",
	"leaves",
	"birthdays",
	"anniversaries",
]);

export type CalendarType = z.infer<typeof calendarType>;

export const calendarTypeFilter = z
	.union([calendarType.array(), calendarType, z.literal("all")])
	.optional();
export type CalendarTypeFilter = z.infer<typeof calendarTypeFilter>;

export const listCalendarDateFilter = z.object({
	startDate: z.string().datetime(),
	endDate: z.string().datetime(),
});
export type ListCalendarDateFilter = z.infer<typeof listCalendarDateFilter>;

export const listCalendarEventsInput = listCalendarDateFilter.extend({
	calendarTypes: calendarTypeFilter,
});

export const calendarEventsList = z
	.object({
		google: externalCalendarEvents.nullable(),
		googleHolidays: externalCalendarEvents.nullable(),
		leaves: leavesCalendar,
		birthdays: birthdaysCalendar,
		anniversaries: anniversariesCalendar,
	})
	.partial();

export type CalendarEventsListDto = z.infer<typeof calendarEventsList>;
